import { render } from "./Header.vue?vue&type=template&id=890522aa"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
script.render = render

export default script